<template>
	<div class="index">
		<!--顶部提示框-->
		<van-notice-bar v-if="prompt" mode="closeable" wrapable :scrollable="false" :text="prompt" />
		<!--头部-->
		<div class="header">
			<div class="logo">
				<img src="../assets/img/logo.png">{{ libName }}
			</div>
			<!--搜索-->
			<van-search
					shape="round"
					left-icon=""
					v-model="searchValue"
					placeholder="输入题名 / 作者 / 出版社 / ISBN"
					background="transparent"
					@search="onSearch">
				<template #right-icon>
					<div class="search-btn" @click="onSearch"><i class="iconfont icon-sousuo"></i>搜索</div>
				</template>
			</van-search>
		</div>
		<!--广告栏-->
		<div class="banner">
			<router-link to="/NewArrival">
				<img src="../assets/img/banner.jpg">
			</router-link>
		</div>
		<!--新书速递-->
		<div class="area">
			<div class="head">
				<div class="title">新书速递</div>
				<div class="right">
					<div class="indicator">
						<span v-for="(item,index) in 3" :key="index" :class="{active : newBookIndex === index}"></span>
					</div>
					<div class="line"></div>
					<router-link class="more-btn" to="/newBook">
						<span>更多</span>
						<van-icon name="arrow"/>
					</router-link>
				</div>
			</div>
			<van-swipe @change="onNewBookChange" :show-indicators="false">
				<van-swipe-item class="row-books" v-for="(item,index) in newBooksList" :key="index">
					<router-link
							class="book-item"
							v-for="(book,bookIndex) in item"
							:key="bookIndex"
							:to="'/bookDetail/' + book.bookId">
						<div class="cover">
							<img v-if="book.coverUrl" :src="book.coverUrl" :key="book.bookId" referrerpolicy="no-referrer" @error="handleErrorImage($event)"/>
							<img v-else :src="defaultCover()" :key="item.bookId"/>
						</div>
						<p class="title van-multi-ellipsis--l2">{{ book.title }}</p>
					</router-link>
				</van-swipe-item>
			</van-swipe>
		</div>
		<!--推荐图书-->
		<div class="area">
			<div class="head">
				<div class="title">推荐图书</div>
				<div class="right">
					<div class="indicator">
						<span v-for="(item,index) in 3" :key="index" :class="{active : recommendIndex === index}"></span>
					</div>
					<div class="line"></div>
					<router-link class="more-btn" to="/recommend">
						<span>更多</span>
						<van-icon name="arrow"/>
					</router-link>
				</div>
			</div>
			<van-swipe @change="onRecommendChange" :loop="true" :show-indicators="false">
				<van-swipe-item class="vertical-books" v-for="(item,index) in recommendList" :key="index">
					<router-link
							class="book-item"
							v-for="(book,bookIndex) in item"
							:key="bookIndex"
							:to="'/bookDetail/' + book.bookId">
						<div class="cover">
							<img v-if="book.coverUrl" :src="book.coverUrl" :key="book.bookId" referrerpolicy="no-referrer" @error="handleErrorImage($event)"/>
							<img v-else :src="defaultCover()" :key="item.bookId"/>
						</div>
						<div class=" right">
							<p class="title van-ellipsis">{{ book.title }}</p>
							<p class="van-ellipsis">{{ book.author }}</p>
							<p class="van-ellipsis">{{ book.publisher }}</p>
							<p>
								<span class="price">￥{{ book.price }}</span>
								<em></em>
								<span class="stock">库存:{{ book.inventory }}</span>
							</p>
						</div>
					</router-link>
				</van-swipe-item>
			</van-swipe>
		</div>
	</div>
</template>

<script>
import {defineComponent, ref, onMounted, computed} from 'vue';
import {Toast} from 'vant';
import store from '@/store';
import router from '../router';
import {SEARCH_NORMAL} from '@/utils/consts';
import {isNotEmpty, randomBookCover, setCovers} from '@/utils/util';
import {chunk} from 'lodash';
import {getNewBookRecommend, getRecommend} from '@/api/books';

export default defineComponent({
	name: 'Index',
	setup() {
    const prompt = computed(() => {
      return store.state.baseConfig['pda.prompt.home'] ?? '';
    });
		const searchValue = ref('');
		const libName = ref('');
		const newBookIndex = ref(0);// 新书速递当前索引
		const newBooksList = ref([]);// 新书速递数据
		const recommendIndex = ref(0);// 推荐图书当前索引
		const recommendList = ref([]);// 推荐图书数据
		const onSearch = () => {
			if (isNotEmpty(searchValue.value)) {
				const params = {
					type: SEARCH_NORMAL,
					param: {query: searchValue.value}
				};
				store.commit('search', params);
				router.push({path: '/searchResults'});
			} else {
				Toast({message: '请输入搜索词'})
			}
		};
		const onNewBookChange = (index) => {
			newBookIndex.value = index;
		};
		const onRecommendChange = (index) => {
			recommendIndex.value = index;
		};
		// 新书速递
		const onNewBookRecommend = () => {
			getNewBookRecommend(1, 18)
					.then(data => {
						if (data && isNotEmpty(data.dataList)) {
							const isbns = [];
							data.dataList.forEach(item => {
								if (isNotEmpty(item.isbn)) {
									isbns.push(item.isbn);
								}
							});
							newBooksList.value = chunk(data.dataList, 6);
							if (isNotEmpty(isbns))
								setCovers(isbns, newBooksList.value, 1)
						}
					})
					.catch((error) => {
						console.error(error);
					});
		};
		// 推荐图书
		const onRecommend = () => {
			getRecommend(1, 18)
					.then(data => {
						if (data && isNotEmpty(data.dataList)) {
							const isbns = [];
							data.dataList.forEach(item => {
								if (isNotEmpty(item.isbn)) {
									isbns.push(item.isbn);
								}
							});
							recommendList.value = chunk(data.dataList, 6);
							if (isNotEmpty(isbns))
								setCovers(isbns, recommendList.value, 1)
						}
					})
					.catch((error) => {
						console.error(error);
					});
		};
		function handleErrorImage(event) {
			event.srcElement.src = randomBookCover();
		}
		function defaultCover(){
			return randomBookCover();
		}
		onMounted(() => {
			// 防止获取不到中心的baseUrl 请求报错
			setTimeout(()=>{
				onNewBookRecommend();
				onRecommend();
			})
			
		});
		
		return {
      prompt,
			onSearch,
			searchValue,
			newBookIndex,
			onNewBookChange,
			newBooksList,
			recommendIndex,
			recommendList,
			onRecommendChange,
			libName,
			handleErrorImage,
			defaultCover
		};
	},
});
</script>

<style scoped lang="less">
@import "../assets/css/index.less";
</style>
